import { gql } from '@apollo/client';
import { CODE_FRAGMENT} from '../../shared/fragments';

export const FETCH_ALL_IMMUNIZATIONS_QUERY = gql`
  query fetchAllImmunizations(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllImmunizations(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      immunizationList
      count
    }
  }
`;

export const FETCH_IMMUNIZATION_DETAILS_BY_ID_QUERY = gql`
  query fetchImmunizationById($immunizationId: String) {
    fetchImmunizationById(immunizationId: $immunizationId) {
      immunization
      docArn
      documentReferenceId
    }
  }
`;

export const FETCH_RELATED_IMMUNIZATIONS = gql`
  query fetchRelatedImmunizations(
    $relatedResourceId: String
    $relatedResourceType: String
  ) {
    fetchRelatedImmunizations(
      resourceId: $relatedResourceId
      resourceType: $relatedResourceType
    ) {
      id
      vaccineCode {
        ...code
      }
      occurrenceDateTime
      site {
        text
        coding {
          display
          code
        }
      }
      route {
        ...code
      }
      location {
        reference
        display
      }
      performer {
        actor {
          reference
          display
        }
        onBehalfOf {
          reference
          display
        }
      }
      doseQuantity {
        value
        unit
        code
      }
      doseNumber
      lotNumber
      manufacturer {
        reference
        display
      }
    }
  }
  ${(CODE_FRAGMENT, CODE_FRAGMENT)}
`;
